var _style, _path, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "414px",
    height: "108px",
    viewBox: "0 0 414 108",
    style: {
      enableBackground: "new 0 0 414 108"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#9F163D;}\n\t.st1{fill:#EB323A;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#EB323A;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.5,25.9c2.6-5,16.4-17.3,27.4-19.6c5-1.1,6.8,1.7,7,5.7c22.4,2.6,43.4,21.5,48.2,44.4 c1.3,6.2,1.3,12.1,0.2,17.5l5.5-0.1c-2.6,7.2-11.3,22.2-31.9,26.5c-0.8,0.2-1.6,0.3-2.3,0.4c-2,0.3-4,0.4-6.1,0.4 c-24.3,0-48.2-20-53.4-44.7C8.7,44.6,10.9,33.9,16.5,25.9z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.71 -0.7042 0.7042 0.71 -16.2995 58.9718)",
    className: "st1",
    cx: 63.5,
    cy: 49.3,
    rx: 39.3,
    ry: 48.7
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7093 -0.7049 0.7049 0.7093 -14.5639 59.0996)",
    className: "st2",
    cx: 64.4,
    cy: 47.2,
    rx: 30.9,
    ry: 38.2
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.6688 -0.7435 0.7435 0.6688 -12.6557 63.7784)",
    className: "st1",
    cx: 65.2,
    cy: 46.1,
    rx: 22.6,
    ry: 27.9
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.6304 -0.7763 0.7763 0.6304 -10.2925 68.4853)",
    className: "st2",
    cx: 66.8,
    cy: 45.1,
    rx: 14.4,
    ry: 17.7
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.6304 -0.7763 0.7763 0.6304 -10.2923 68.4861)",
    className: "st1",
    cx: 66.8,
    cy: 45.1,
    rx: 7.1,
    ry: 8.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M179.3,75c0,0.6,0.4,1,1,1h7.6c0.6,0,1-0.4,1-1V38.5h-8.6c-0.6,0-1,0.4-1,1V75z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M179.6,32.5c0.9,1,2.3,1.5,4.2,1.5s3.3-0.5,4.1-1.5c0.9-1,1.3-2.3,1.3-3.7c0-1.6-0.4-2.8-1.3-3.8 c-0.9-1-2.3-1.5-4.1-1.5s-3.3,0.5-4.2,1.5c-0.9,1-1.3,2.2-1.3,3.8C178.3,30.3,178.7,31.5,179.6,32.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M164.2,58.5c-2.9,1.4-6.5,2.1-10.8,2.1h-7.6V75c0,0.6-0.4,1-1,1H137c-0.6,0-1-0.4-1-1V26.2c0-0.6,0.4-1,1-1h7.8 c0.1,0,0.2,0,0.3,0c0.1,0,0.2,0,0.3,0h8c4.2,0,7.8,0.7,10.8,2.1c3,1.4,5.3,3.4,6.8,5.9c1.6,2.5,2.3,5.5,2.3,9v1.1 c0,3.5-0.8,6.5-2.3,9.1C169.4,55,167.1,57,164.2,58.5z M159.2,34.9c-1.3-0.8-3-1.2-5-1.2h-8.4V52h8.4c2,0,3.6-0.4,5-1.2 c1.4-0.8,2.4-1.9,3.1-3.2c0.7-1.4,1.1-3,1.1-4.8c0-1.8-0.4-3.4-1.1-4.8C161.6,36.7,160.6,35.6,159.2,34.9z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M197.5,76c-0.6,0-1-0.4-1-1V39.5c0-0.6,0.4-1,1-1h5.6c0.6,0,1,0.4,1,1v8.2c0.2-1,0.5-1.9,0.8-2.7 c1-2.6,2.5-4.5,4.5-5.8c2-1.3,4.5-1.9,7.5-1.9h0.4c4.5,0,7.9,1.5,10.2,4.4c2.3,2.9,3.5,7.1,3.5,12.8V75c0,0.6-0.4,1-1,1h-7.6 c-0.6,0-1-0.4-1-1V53.7c0-2.3-0.7-4.2-2-5.6c-1.3-1.4-3.1-2.1-5.4-2.1c-2.3,0-4.3,0.7-5.7,2.2c-1.4,1.4-2.1,3.4-2.1,5.8v21 c0,0.6-0.4,1-1,1H197.5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M266.8,58.5c-2.9,1.4-6.5,2.1-10.8,2.1h-7.6V75c0,0.6-0.4,1-1,1h-7.8c-0.6,0-1-0.4-1-1V26.2c0-0.6,0.4-1,1-1 h7.8c0.1,0,0.2,0,0.3,0c0.1,0,0.2,0,0.3,0h8c4.2,0,7.8,0.7,10.8,2.1c3,1.4,5.3,3.4,6.8,5.9c1.6,2.5,2.3,5.5,2.3,9v1.1 c0,3.5-0.8,6.5-2.3,9.1C272.1,55,269.8,57,266.8,58.5z M261.8,34.9c-1.3-0.8-3-1.2-5-1.2h-8.4V52h8.4c2,0,3.6-0.4,5-1.2 c1.4-0.8,2.4-1.9,3.1-3.2c0.7-1.4,1.1-3,1.1-4.8c0-1.8-0.4-3.4-1.1-4.8C264.2,36.7,263.2,35.6,261.8,34.9z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M297.3,77.3c-3.3,0-6.2-0.5-8.8-1.6c-2.5-1.1-4.7-2.5-6.4-4.3c-1.8-1.8-3.1-3.9-4-6.2c-0.9-2.3-1.3-4.7-1.3-7.2 v-1.5c0-2.6,0.5-5,1.4-7.3c1-2.3,2.3-4.4,4.1-6.2c1.8-1.8,4-3.3,6.5-4.3c2.5-1.1,5.4-1.6,8.6-1.6c3.2,0,6,0.5,8.6,1.6 c2.5,1,4.7,2.4,6.4,4.3c1.8,1.8,3.2,3.9,4.1,6.2c0.9,2.3,1.4,4.7,1.4,7.3V58c0,2.5-0.5,4.9-1.4,7.2c-0.9,2.3-2.2,4.4-3.9,6.2 c-1.8,1.8-3.9,3.2-6.4,4.3C303.5,76.8,300.6,77.3,297.3,77.3z M297.3,69.1c2.3,0,4.3-0.5,5.9-1.5c1.6-1.1,2.8-2.5,3.7-4.2 c0.8-1.8,1.2-3.8,1.2-6.1c0-2.3-0.4-4.3-1.3-6.1c-0.8-1.8-2.1-3.2-3.7-4.2c-1.6-1.1-3.5-1.6-5.8-1.6c-2.3,0-4.2,0.5-5.9,1.6 c-1.6,1-2.9,2.4-3.7,4.2c-0.9,1.8-1.3,3.8-1.3,6.1c0,2.3,0.4,4.3,1.2,6.1c0.9,1.8,2.1,3.2,3.7,4.2C293,68.6,295,69.1,297.3,69.1z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M324.5,75c0,0.6,0.4,1,1,1h7.6c0.6,0,1-0.4,1-1V38.5h-8.6c-0.6,0-1,0.4-1,1V75z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M324.8,32.5c0.9,1,2.3,1.5,4.2,1.5c1.9,0,3.3-0.5,4.1-1.5c0.9-1,1.3-2.3,1.3-3.7c0-1.6-0.4-2.8-1.3-3.8 c-0.9-1-2.3-1.5-4.1-1.5c-1.9,0-3.3,0.5-4.2,1.5c-0.9,1-1.3,2.2-1.3,3.8C323.5,30.3,324,31.5,324.8,32.5z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M342.8,76c-0.6,0-1-0.4-1-1V39.5c0-0.6,0.4-1,1-1h5.6c0.6,0,1,0.4,1,1v8.2c0.2-1,0.5-1.9,0.8-2.7 c1-2.6,2.5-4.5,4.5-5.8c2-1.3,4.5-1.9,7.5-1.9h0.4c4.5,0,7.9,1.5,10.2,4.4c2.3,2.9,3.5,7.1,3.5,12.8V75c0,0.6-0.4,1-1,1h-7.6 c-0.6,0-1-0.4-1-1V53.7c0-2.3-0.7-4.2-2-5.6c-1.3-1.4-3.1-2.1-5.4-2.1c-2.3,0-4.3,0.7-5.7,2.2c-1.4,1.4-2.1,3.4-2.1,5.8v21 c0,0.6-0.4,1-1,1H342.8z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M390.8,75.2c2.3,0.9,5.1,1.3,8.6,1.3h4.4c0.6,0,1-0.4,1-1v-6.2c0-0.6-0.4-1-1-1h-4.9c-1.8,0-3.3-0.5-4.3-1.5 c-1-1-1.5-2.4-1.5-4.3l0-17h10.6c0.6,0,1-0.4,1-1v-5c0-0.6-0.4-1-1-1h-10.6l0-9.6c0-0.6-0.4-1-1-1h-7c-0.6,0-1,0.4-1,1l0,9.6h-5 c-0.6,0-1,0.4-1,1v5c0,0.6,0.4,1,1,1h5l0,16.4c0,3.6,0.6,6.5,1.7,8.7C387,72.7,388.6,74.3,390.8,75.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg02);
export default __webpack_public_path__ + "static/media/02.cad995911adb0da24121d5ac1c2444e8.svg";
export { ForwardRef as ReactComponent };